import axios from "../axiosInstance";
import {
  FetchCampaignBillingBatchesRequest,
  FetchCampaignBillingBatchesResponse,
  GenerateInvoicesRequest,
  GenerateInvoicesResponse,
} from "./types";

export const fetchCampaignBillingBatches = async (
  requestData: FetchCampaignBillingBatchesRequest,
): Promise<FetchCampaignBillingBatchesResponse> => {
  // Transform frontend parameter names to match backend API expectations
  const apiParams: Record<string, any> = {};

  if (requestData.weeks && requestData.weeks.length > 0) {
    apiParams.weekNumbers = requestData.weeks;
  }
  if (requestData.year !== undefined) {
    apiParams.yearNumber = requestData.year;
  }
  if (requestData.batchStatusId !== undefined) {
    apiParams.batchStatusId = requestData.batchStatusId;
  }
  if (requestData.page !== undefined) {
    apiParams.page = requestData.page;
  }
  if (requestData.perPage !== undefined) {
    apiParams.perPage = requestData.perPage;
  }
  if (requestData.sortOrder !== undefined) {
    apiParams.sortOrder = requestData.sortOrder;
  }
  if (requestData.sortBy !== undefined) {
    apiParams.sortBy = requestData.sortBy;
  }
  if (requestData.searchTerm !== undefined) {
    apiParams.searchTerm = requestData.searchTerm;
  }
  if (requestData.billingType !== undefined) {
    apiParams.billingType = requestData.billingType;
  }

  const response = await axios.get<FetchCampaignBillingBatchesResponse>(
    "/api/private/stochastic/campaign-billing/batches",
    {
      params: apiParams,
    },
  );
  return response.data;
};

export const generateInvoices = async (
  data: GenerateInvoicesRequest,
): Promise<GenerateInvoicesResponse> => {
  const response = await axios.post<GenerateInvoicesResponse>(
    "/api/private/stochastic/campaign-billing/batches",
    data,
  );
  return response.data;
};
